import { render, staticRenderFns } from "./AssetSearch.vue?vue&type=template&id=24a39aaa&scoped=true"
import script from "./AssetSearch.vue?vue&type=script&lang=js"
export * from "./AssetSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a39aaa",
  null
  
)

export default component.exports